// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../rescript/lib/es6/array.js";
import * as $$String from "../../../../rescript/lib/es6/string.js";
import * as Caml_array from "../../../../rescript/lib/es6/caml_array.js";
import * as QueryParamsConstructor$Catalyst from "../helper-modules/query-params/QueryParamsConstructor.bs.js";

function getURLParams(searchStr) {
  var urlParams = {};
  $$Array.iter((function (param) {
          var params = param.split("=");
          if (params.length >= 2) {
            urlParams[Caml_array.get(params, 0)] = Caml_array.get(params, 1);
            return ;
          }
          
        }), searchStr.split("&"));
  return urlParams;
}

function createRequestURLfrmParams(hostName, requestUrl, urlParams) {
  var args = QueryParamsConstructor$Catalyst.create(urlParams);
  if (args !== undefined) {
    return hostName + (requestUrl + ("?" + args));
  } else {
    return hostName + requestUrl;
  }
}

function getAnchorElement(url) {
  var $$document = window.document;
  var elem = $$document.createElement("a");
  elem.setAttribute("href", url);
  return elem;
}

function getHostName(url) {
  var elem = getAnchorElement(url);
  if (elem.port === "") {
    return elem.hostname;
  } else {
    return $$String.concat(":", {
                hd: elem.hostname,
                tl: {
                  hd: elem.port,
                  tl: /* [] */0
                }
              });
  }
}

function getPathSplitParts(url) {
  var $$location = getAnchorElement(url).pathname.split("/");
  return $$Array.sub($$location, 1, $$location.length - 1 | 0);
}

function getSearchParams(url) {
  return getAnchorElement(url).search.substr(1);
}

function getCurrentPageHost(param) {
  return window.location.host;
}

export {
  getURLParams ,
  createRequestURLfrmParams ,
  getAnchorElement ,
  getHostName ,
  getPathSplitParts ,
  getSearchParams ,
  getCurrentPageHost ,
  
}
/* No side effect */
